import React, { useMemo, useState } from "react";
import { Box, useTheme } from "@mui/material";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import UserDetailsTableDetailsPanel from "./UserDetailsTableDetailsPanel";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import ExpandButtonGroup from "../../common/ExpandButtonGroup.table";

type userDetails = {
  id: string;
  organization: string;
  cohort: string;
  team: string;
  role: string;
};

const userDetailsColumns: MRT_ColumnDef<userDetails>[] = [
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Email",
    accessorKey: "email",
  },
  {
    header: "Organization",
    accessorKey: "organizationName",
  },
  {
    header: "Organization Type",
    accessorKey: "organizationType",
  },
];


const UserDetailsTable = ({userDetails, usersOrg}) => {

  const [selectedTable, setSelectedTable] = useState("Details");
  const columns = useMemo<MRT_ColumnDef<userDetails>[]>(
    () => userDetailsColumns,
    []
  );
  const theme = useTheme()

  const getRows = () =>
    usersOrg?.orgs?.map((org) => ({
      ...org,
      name: userDetails?.username,
      email:userDetails?.email
    }));
    
  return (
    <Box    
      sx={{
        'tbody tr:has(> td[colspan]:empty)': {
          display: 'none !important',
        },
      }}
    >
      <AdminGlobalTable
        columns={columns}
        data={getRows()}
        config={{
          enablePagination: false,
          enableRowVirtualization: false,
          enableColumnVirtualization: false,
          enableStickyHeader: true,
         // muiSelectCheckboxProps: { color: "secondary" },

          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              height: "78px",
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme?.custom?.hoverOptionColor },
            },
          }),
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 560px)",
              minHeight: "calc(100vh - 560px)",
            },
          },
          muiExpandButtonProps: ({ row }) => {
            return {
              children: (
                <ExpandButtonGroup
                  row={row}
                  selectedTable={selectedTable}
                  setSelectedTable={setSelectedTable}
                  buttons={[
                    { key: "Roles", label: "Roles" },
                    { key: "License", label: "License" },
                  ]}
                />
              ),
            };
          },
          renderDetailPanel: ({ row }) => {
            return (
              <Box sx={{ marginLeft: "130px" }}>
                <UserDetailsTableDetailsPanel
                  row={row}
                  selectedTable={selectedTable}
                />
              </Box>
            );
          },
        }}
      />
    </Box>
  );
};

export default UserDetailsTable;
